module.exports = __webpack_public_path__ + "static/assets/d5daff71b359c33eb3d8a6647567d53a.png";